import Auth from "./AuthHoc";
import { Route, Switch } from "react-router-dom";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import Dashboard from "./components/pages/dashboard";
import Configurations from "./components/tabs/Configurations";
import BluePrintNew from "./components/pages/blueprint";
import BackupRestore from './components/pages/backupRestore'
import Layout from './themes/classic/Layout';
import 'font-awesome/css/font-awesome.min.css';
import Joyride from "react-joyride";
import useTour from "./hooks/useTour";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { addTourConfig, invokeGetService } from "./store/global/actions";
import useSocket from "./hooks/useSocket";
import { connectSocket, disconnectSocket } from "./websocket/socketProvider";

TimeAgo.addDefaultLocale(en);

function App() {
	useSocket();
	const token = useMemo(() => localStorage.getItem("token"), []);
	const {run, steps, stepIndex, otherAttributes, handleJoyrideCallback, config} = useTour();
	const dispatch = useDispatch()

	const fetchTourConfig = async () => {
		const data = await dispatch(invokeGetService('tourConfig'))
		if(data){
			dispatch(addTourConfig(data))
		}
	}

	useEffect(() => {
		if(!config){
			fetchTourConfig()
		}
	},[config])

	useEffect(() => {
		if(token){
			connectSocket(token)
		}

		return () => {
			disconnectSocket()
		}
	},[token])

	return (
		<main>
			<Joyride
				callback={handleJoyrideCallback}
				{...otherAttributes}
				run={run}
				steps={steps}
				stepIndex={stepIndex}
				styles={{
				  options: {
					zIndex: 10000,
				  },
				}}
			/>
			{/* <Suspense fallback={<div>Loading...</div>}> */}
			<Switch>
				<Layout>
					<Route path="/" component={Dashboard} exact></Route>
					<Route path="/configuration" component={Configurations} exact />
					<Route path="/blueprint/:slug/:id/:tag/:transaction?" component={BluePrintNew} exact />
					<Route path="/backup-and-restore" component={BackupRestore} exact />
				</Layout>
			</Switch>
			{/* </Suspense> */}
		</main>
	);
}

export default Auth(App);
